import { FunnelImage } from './MediaData';

export enum StoryVariant {
  INTRO = 'INTRO',
  BASIC = 'BASIC',
  MEDIA = 'MEDIA',
}

export type StoryColorVariant = 'DARK' | 'LIGHT';

export type StoryIntroContent = {
  image: FunnelImage;
  title: string;
  text: string;
  caption?: string;
  footerIcon?: FunnelImage;
  colorVariant?: StoryColorVariant;
  variant: StoryVariant.INTRO;
};

export type StoryBasicContent = {
  image: FunnelImage;
  title: string;
  text: string;
  colorVariant?: StoryColorVariant;
  variant: StoryVariant.BASIC;
};

export type StoryMediaContent = {
  headerImage?: FunnelImage;
  image?: FunnelImage;
  title: string;
  text: string;
  colorVariant?: StoryColorVariant;
  variant: StoryVariant.MEDIA;
};

export type Story = StoryIntroContent | StoryBasicContent | StoryMediaContent;
